import nativeApi from './nativeApi'


// 路由管理工具
let routerTool = {}

routerTool.routerCloseWebview = function(to, from, next){
    if(to.path != from.path && to.path == '/'){
        nativeApi.nativeFN.closeWindow()
    }
}

export default routerTool


// WEBPACK FOOTER //
// ./src/common/tool/routerTool.js